import { Clone, useGLTF } from '@react-three/drei'
import { useControls } from 'leva'

export default function ScrewDriver()
{
    const model = useGLTF('./models/tools/flathead_screwdriver/flathead_screwdriver_1k.gltf')
    model.scene.children[0].castShadow = true

    const leva = useControls('screwdriver', {
        position:{ x:-0.60, y:-0.862, z:0.0 },
        rotation:{ x:0, y:0, z:-Math.PI },
        spread:{ value:0.88, min:0, max:3 },
        angle:{ value:1, min:0, max:3 }
    },
    { collapsed: true }
    )
    
    return <>    
        <Clone
            object={model.scene}
            position={[
                leva.position.x + (Math.random()-0.5) * leva.spread,
                leva.position.y,
                leva.position.z + (Math.random()-0.5) * leva.spread ]}
            rotation={[ 
                leva.rotation.x + (Math.random()-0.5) * leva.angle,
                leva.rotation.y + (Math.random()-0.5) * leva.angle,
                leva.rotation.z + (Math.random()-0.5) * leva.angle ]}
        />
        <Clone
            object={model.scene}
            position={[
                leva.position.x + (Math.random()-0.5) * leva.spread,
                leva.position.y,
                leva.position.z + (Math.random()-0.5) * leva.spread ]}
            rotation={[ 
                leva.rotation.x + (Math.random()-0.5) * leva.angle,
                leva.rotation.y + (Math.random()-0.5) * leva.angle,
                leva.rotation.z + (Math.random()-0.5) * leva.angle ]}
        />
        <Clone
            object={model.scene}
            position={[
                leva.position.x + (Math.random()-0.5) * leva.spread,
                leva.position.y,
                leva.position.z + (Math.random()-0.5) * leva.spread ]}
            rotation={[ 
                leva.rotation.x + (Math.random()-0.5) * leva.angle,
                leva.rotation.y + (Math.random()-0.5) * leva.angle,
                leva.rotation.z + (Math.random()-0.5) * leva.angle ]}
        />
        <Clone
            object={model.scene}
            position={[
                leva.position.x + (Math.random()-0.5) * leva.spread,
                leva.position.y,
                leva.position.z + (Math.random()-0.5) * leva.spread ]}
            rotation={[ 
                leva.rotation.x + (Math.random()-0.5) * leva.angle,
                leva.rotation.y + (Math.random()-0.5) * leva.angle,
                leva.rotation.z + (Math.random()-0.5) * leva.angle ]}
        />
        <Clone
            object={model.scene}
            position={[
                leva.position.x + (Math.random()-0.5) * leva.spread,
                leva.position.y,
                leva.position.z + (Math.random()-0.5) * leva.spread ]}
            rotation={[ 
                leva.rotation.x + (Math.random()-0.5) * leva.angle,
                leva.rotation.y + (Math.random()-0.5) * leva.angle,
                leva.rotation.z + (Math.random()-0.5) * leva.angle ]}
        />
        <Clone
            object={model.scene}
            position={[
                leva.position.x + (Math.random()-0.5) * leva.spread,
                leva.position.y,
                leva.position.z + (Math.random()-0.5) * leva.spread ]}
            rotation={[ 
                leva.rotation.x + (Math.random()-0.5) * leva.angle,
                leva.rotation.y + (Math.random()-0.5) * leva.angle,
                leva.rotation.z + (Math.random()-0.5) * leva.angle ]}
        />
        <Clone
            object={model.scene}
            position={[
                leva.position.x + (Math.random()-0.5) * leva.spread,
                leva.position.y,
                leva.position.z + (Math.random()-0.5) * leva.spread ]}
            rotation={[ 
                leva.rotation.x + (Math.random()-0.5) * leva.angle,
                leva.rotation.y + (Math.random()-0.5) * leva.angle,
                leva.rotation.z + (Math.random()-0.5) * leva.angle ]}
        />
    </>
}